import { ApiResponse } from '../models/api/api-response.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '../constants/api';

@Injectable({
  providedIn: 'root',
})
export class TechService {
  constructor(private http: HttpClient) {}

  getUserTechListing(userId?: string) {
    return this.http.get<ApiResponse<any>>(API.userTechListing(userId), {
      withCredentials: true,
    });
  }

  getUserTechAggregateListing(userId?: string) {
    return this.http.get<ApiResponse<any>>(
      API.userTechAggregateListing(userId),
      { withCredentials: true },
    );
  }

  getUserTechMessages(userId?: string) {
    return this.http.get<ApiResponse<any>>(API.userTechMessages(userId), {
      withCredentials: true,
    });
  }

  postUserTechMessage(userId?: string, data?: object) {
    return this.http.post(API.userTechMessage(userId), data, {
      withCredentials: true,
    });
  }

  getTechBlockDetails(docId?: string) {
    return this.http.get<ApiResponse<any>>(API.techBlock(docId), {
      withCredentials: true,
    });
  }

  deleteTechBlock(docId?: string) {
    return this.http.delete<ApiResponse<any>>(API.techBlock(docId), {
      withCredentials: true,
    });
  }

  getDocument(docId?: string) {
    return this.http.get(API.techDocument(docId), {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
    });
  }

  deleteDocument(docId?: string) {
    return this.http.delete(API.techDocument(docId), {
      withCredentials: true,
    });
  }

  // ASSIGNMENT
  postAssignment(data: { owner: string; device: string }) {
    return this.http.post<ApiResponse<any>>(
      API.techUserPost(data.owner, 'assignment'),
      data,
      { withCredentials: true },
    );
  }

  // INSURANCE
  postInsurance(formData?: FormData, userId?: string) {
    return this.http.post(API.techUserPost(userId, 'insurance'), formData, {
      withCredentials: true,
    });
  }

  patchInsurance(formData?: FormData, blockId?: string) {
    return this.http.patch(API.techPatch(blockId, 'insurance'), formData, {
      withCredentials: true,
    });
  }

  // LOSS
  postLoss(formData?: FormData, userId?: string) {
    return this.http.post(API.techUserPost(userId, 'loss'), formData, {
      withCredentials: true,
    });
  }

  patchLoss(formData?: FormData, blockId?: string) {
    return this.http.patch(API.techPatch(blockId, 'loss'), formData, {
      withCredentials: true,
    });
  }

  // BREAKING
  postBreaking(data?: { owner?: string }) {
    return this.http.post<ApiResponse<any>>(
      API.techUserPost(data?.owner, 'breaking'),
      data,
      { withCredentials: true },
    );
  }

  patchBreaking(blockId?: string, data?: { owner?: string }) {
    return this.http.patch<ApiResponse<any>>(
      API.techPatch(blockId, 'breaking'),
      data,
      {
        withCredentials: true,
      },
    );
  }

  // RETURN
  postReturn(data?: { owner?: string }) {
    return this.http.post<ApiResponse<any>>(
      API.techUserPost(data?.owner, 'return'),
      data,
      { withCredentials: true },
    );
  }

  patchReturn(blockId?: string, data?: { owner?: string }) {
    return this.http.patch<ApiResponse<any>>(
      API.techPatch(blockId, 'return'),
      data,
      { withCredentials: true },
    );
  }

  // RELEASE
  postRelease(formData?: FormData, userId?: string) {
    return this.http.post(API.techUserPost(userId, 'release'), formData, {
      withCredentials: true,
    });
  }

  patchRelease(formData?: FormData, blockId?: string) {
    return this.http.patch(API.techPatch(blockId, 'release'), formData, {
      withCredentials: true,
    });
  }

  // GENERAL AGGREGATE LISTING
  getTechAggregateListing(p: {
    txt?: string;
    page?: number;
    limit?: number;
    schoolYear?: string;
    headquarter?: string;
    types?: string[];
    from?: string;
    to?: string;
  }) {
    let params = new HttpParams();
    if (p.page) params = params.set('page', p.page);
    if (p.limit) params = params.set('limit', p.limit);
    if (p.schoolYear && !p.from && !p.to) {
      params = params.set('y', p.schoolYear.trim());
    } else {
      if (p.from) {
        params = params.set('from', p.from.trim().split('T').at(0) ?? '');
      }
      if (p.to) params = params.set('to', p.to.trim().split('T').at(0) ?? '');
    }
    if (p.headquarter) {
      params = params.set('h', p.headquarter.toUpperCase().trim());
    }
    if (p.types) {
      params = params.set('types', p.types.join(',').toLowerCase().trim());
    }
    if (p.txt) params = params.set('txt', p.txt.trim());
    return this.http.get(API.techAggregateListing(), {
      withCredentials: true,
      params,
    });
  }
}
